import { gql } from '@apollo/client';

export default gql`
  mutation createWorkTicket(
    $branch: String
    $time: Date
    $title: String
    $desc: String
    $items: String
    $contract: ContractInput
    $department: DepartmentInput
    $employee: EmployeeInput
    $bonos: Float
    $overtime: Float
    $deduction: Float
    $isWorking: Int
    $isAbsent: Int
    $isShift1: Int
    $isShift2: Int
    $userId: String
    $note: String
  ) {
    createWorkTicket(
      branch: $branch
      time: $time
      title: $title
      desc: $desc
      items: $items
      contract: $contract
      department: $department
      employee: $employee
      bonos: $bonos
      overtime: $overtime
      deduction: $deduction
      isWorking: $isWorking
      isAbsent: $isAbsent
      isShift1: $isShift1
      isShift2: $isShift2
      userId: $userId
      note: $note
    ) {
      ok
      message
      data
      error
    }
  }
`;
